import React, { useEffect, useState } from "react";
import { IDS } from "@/constants/testIds";
import { Terminal } from "lucide-react";

const links = [
  { id: "services", label: "Services", tid: IDS.navServices },
  { id: "process", label: "Process", tid: IDS.navProcess },
  { id: "stack", label: "Tech Stack", tid: IDS.navStack },
  { id: "contact", label: "Contact", tid: IDS.navContact },
];

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid={IDS.nav}
      className={`sticky top-0 z-50 transition-colors ${
        scrolled
          ? "bg-black/85 backdrop-blur-md border-b border-[rgba(0,255,65,0.2)]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1280px] px-6 lg:px-10 h-16 flex items-center justify-between">
        <a
          href="#top"
          data-testid={IDS.navLogo}
          className="flex items-center gap-2 group"
        >
          <span className="grid place-items-center w-7 h-7 border border-[rgba(0,255,65,0.5)] text-[#00FF41]">
            <Terminal size={14} strokeWidth={1.5} />
          </span>
          <span className="font-mono text-sm tracking-[0.18em] uppercase">
            <span className="text-white">aetheria</span>
            <span className="text-[#00FF41]">.sh</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              data-testid={l.tid}
              className="link-line text-[11px] uppercase tracking-[0.22em] text-zinc-400 hover:text-white"
            >
              <span className="text-[#00FF41] mr-1">/</span>
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          data-testid={IDS.navCta}
          className="btn-term hidden sm:inline-flex"
        >
          [ Start Build ]
        </a>
      </div>
    </header>
  );
};

export default Nav;
